module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("今天作业")]), _vm._v(" "), (_vm.todayTodos.length > 0) ? _c('group', {
    attrs: {
      "title": "今天新布置作业"
    }
  }, _vm._l((_vm.todayTodos), function(hw) {
    return _c('cell', {
      key: hw.id,
      staticClass: "homework",
      attrs: {
        "title": hw.title,
        "inline-desc": _vm.courseById(hw.course_instance_id).course.name,
        "link": ("/homework/" + (hw.id))
      }
    }, [_c('div', [_c('due-day', {
      attrs: {
        "date": hw.due_date
      }
    })], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.dueTodos.length > 0) ? _c('group', {
    attrs: {
      "title": "未完成作业"
    }
  }, _vm._l((_vm.dueTodos), function(hw) {
    return _c('cell', {
      key: hw.id,
      staticClass: "homework",
      attrs: {
        "title": hw.title || hw.assignment,
        "inline-desc": _vm.courseById(hw.course_instance_id).course.name,
        "link": ("/homework/" + (hw.id))
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "8px",
        "padding-top": "3px"
      }
    }, [(hw.hasAttachment) ? _c('img', {
      attrs: {
        "src": require("../assets/attachment.svg"),
        "width": "18px"
      }
    }) : _vm._e()]), _c('due-day', {
      attrs: {
        "date": hw.due_date
      }
    })], 1)])
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6434ad20"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeworkList.vue
// module id = 559
// module chunks = 1